module.exports = __webpack_public_path__ + "img/desc_bottom_blfgc01.af1b6108.png";